// scroll bar
import "simplebar/src/simplebar.css";

// lightbox
/* eslint-disable import/no-unresolved */
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

// map
import "./utils/mapboxgl";
import "mapbox-gl/dist/mapbox-gl.css";

// editor
import "react-quill/dist/quill.snow.css";

// slick-carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// lazy image
import "react-lazy-load-image-component/src/effects/blur.css";

// ----------------------------------------\
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

// @mui
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { ConfirmProvider } from "material-ui-confirm";

// MSAL
import { MsalProvider } from "@azure/msal-react";

// routes
import Router from "./routes";

// theme
import ThemeProvider from "./theme";

// components
import { StyledChart } from "./components/chart";
import SnackbarProvider from "./components/snackbar";
import ScrollToTop from "./components/scroll-to-top";
import { MotionLazyContainer } from "./components/animate";
import { ThemeSettings, SettingsProvider } from "./components/settings";

// MSAL auth
import { msalInstance } from "./auth/msal";

export default function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <HelmetProvider>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <SettingsProvider>
            <BrowserRouter>
              <ScrollToTop />
              <MotionLazyContainer>
                <ThemeProvider>
                  <ThemeSettings>
                    <ConfirmProvider>
                      <SnackbarProvider>
                        <StyledChart />
                        <Router />
                      </SnackbarProvider>
                    </ConfirmProvider>
                  </ThemeSettings>
                </ThemeProvider>
              </MotionLazyContainer>
            </BrowserRouter>{" "}
          </SettingsProvider>
        </LocalizationProvider>
      </HelmetProvider>
    </MsalProvider>
  );
}
